<template>
  <side-bar
    class="appointment-month-side-bar"
    v-bind:value="isCollapsed"
    v-bind:hide-collapse="hideCollapse"
    v-on:input="$emit('collapse', $event)">
    <date-picker
      v-bind:today="$options.today"
      v-bind:range="range"
      v-on:change-month="onChangeMonth"
      v-model="date" />
    <div class="appointment-month-side-bar__content">
      <button
        class="appointment-month-side-bar__row__button"
        type="button"
        v-on:click="onSelectToday">
        Сегодня
      </button>
      <div class="appointment-month-side-bar__row">
        <button
          class="appointment-month-side-bar__row__button"
          type="button"
          v-bind:class="{ selected: period === $options.periodDay }"
          v-on:click="onSelectAppointmentPeriod($options.periodDay)">День</button>
        <button
          class="appointment-month-side-bar__row__button"
          type="button"
          v-bind:class="{ selected: period === $options.periodWeek }"
          v-on:click="onSelectAppointmentPeriod($options.periodWeek)">Неделя</button>
        <button
          v-click-outside="() => { isShowTooltipMonth = false }"
          class="appointment-month-side-bar__row__button"
          type="button"
          v-bind:class="{ selected: period === $options.periodMonth }"
          v-on:click="onSelectAppointmentPeriod($options.periodMonth)">Месяц</button>
      </div>
      <section class="appointment-month-side-bar__categories" ref="categories">
        <button
          type="button"
          class="appointment-month-side-bar__categories__item"
          v-bind:class="{ selected: showCategory === $options.categoryEmployees }"
          v-on:click="onSelectAppointmentCategory($options.categoryEmployees)">
          Сотрудники
        </button>
        <button
          type="button"
          class="appointment-month-side-bar__categories__item"
          v-bind:class="{ selected: showCategory === $options.categoryCabinets }"
          v-on:click="onSelectAppointmentCategory($options.categoryCabinets)">
          Кресла
        </button>
        <span
          class="appointment-month-side-bar__categories__line"
          ref="underLine" />
      </section>
      <section
        class="appointment-month-side-bar__list"
        v-if="showCategory === $options.categoryEmployees">
        <div v-if="isEmployeesEmpty">Работающих сотрудников нет</div>
        <button
          type="button"
          class="appointment-month-side-bar__list__item"
          v-bind:class="{ selected: item.id === selectedEmployeeId }"
          v-bind:title="item.text"
          v-bind:key="item.id"
          v-for="item in employeeList"
          v-on:click="onSelectEmployee(item.id)">{{ item.name }} <span>{{item.positions}}</span>
        </button>
      </section>
      <section
        class="appointment-month-side-bar__list"
        v-if="showCategory === $options.categoryCabinets">
        <button
          type="button"
          class="appointment-month-side-bar__list__item"
          v-bind:class="{ selected: id === selectedCabinetId }"
          v-bind:key="id"
          v-for="{ id, name } in cabinetList"
          v-on:click="onSelectCabinet(id)">{{ name }}</button>
      </section>
    </div>
  </side-bar>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';
import SideBar from '@/components/SideBar.vue';
import appointmentScheduleMixin from '@/mixins/appointmentScheduleMixin';

export default {
  components: {
    DatePicker,
    SideBar,
  },
  computed: {
    /**
     * @description Идентификаторы кабинетов.
     * @type {number[]}
     */
    selectedCabinetIds: ({ selectedCabinetId }) => (
      selectedCabinetId ? [selectedCabinetId] : []
    ),
    /**
     * @description Список сотрудников пуст.
     * @type {boolean}
     */
    isEmployeesEmpty: ({ employeeList }) => employeeList.length === 0,
  },
  data() {
    return {
      showCategory: this.initialCategory,
      period: 'month',
      selectedCabinetId: this.initialCabinetId || -1,
    };
  },
  methods: {
    /**
     * @description Обработать событие изменения месяца.
     * @param {string} yearAndMonth Год и месяц.
     * @returns {void}
     */
    onChangeMonth(yearAndMonth) {
      if (yearAndMonth !== this.$route.params.month) {
        this.date = new Date(`${yearAndMonth}-01`);
      }
    },
    /**
     * @description Обработать выбор категории расписания.
     * @param {string} category
     * @returns {void}
     */
    onSelectAppointmentCategory(category) {
      this.showCategory = category;
      const index = category === this.$options.categoryCabinets ? 1 : 0;
      this.animate(index);
    },
    /**
     * @description Обработать выбор сотрудника.
     * @param {number} id Идентификатор сотрудника.
     * @returns {void}
     */
    onSelectEmployee(id) {
      this.selectedEmployeeId = id;
      this.category = this.$options.categoryEmployees;
    },
    /**
     * @description Обработать выбор периода построения расписания.
     * @param {string} period
     * @returns {void}
     */
    onSelectAppointmentPeriod(period) {
      this.period = period;
    },
    /**
     * @description Обработать выбор кабинета.
     * @param {number} id Идентификатор кабинета.
     * @returns {void}
     */
    onSelectCabinet(id) {
      this.selectedCabinetId = id;
      this.category = this.$options.categoryCabinets;
    },
    /**
     * @description Обработать выбор на сегодняшний день
     * @returns {void}
     */
    onSelectToday() {
      this.period = this.$options.periodDay;
      this.date = new Date();
    },
    animate(index) {
      const container = this.$refs.categories.getBoundingClientRect();
      const tab = this.$refs.categories.childNodes[index].getBoundingClientRect();
      this.$refs.underLine.style.left = `${tab.left - container.left}px`;
      this.$refs.underLine.style.width = `${tab.width}px`;
    },
  },
  mounted() {
    const index = this.category === this.$options.categoryCabinets ? 1 : 0;
    this.animate(index);
  },
  mixins: [appointmentScheduleMixin],
  props: {
    /**
     * @description Свернут.
     * @type {boolean}
     */
    isCollapsed: { type: Boolean, default: () => false },
    /**
     * @description Список идентификаторов выбранных кабинетов.
     * @type {number[]}
     */
    initialCabinetId: { type: Number, default: -1 },
    hideCollapse: { type: Boolean, default: () => false },
  },
  allEmployeesValue: 'all',
  /**
   * @description Текущее время.
   * @type {Date}
   */
  today: new Date(),
  watch: {
    viewQuery(value) {
      this.openAppointmentSchedule(value);
    },
  },
};
</script>

<style lang="scss">
.appointment-month-side-bar {
  &__content {
    padding: 0 12px 60px 12px;
  }
  &__categories {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 30px;
    position: relative;
    text-align: center;
    &__item {
      color: var(--reading-color);
      cursor: pointer;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      padding-bottom: 8px;
      border-bottom: 1px solid #707683;
      &.select,
      &:hover {
        color: var(--action-color);
      }
    }
    &__line {
      background: #0489e0;
      height: 2px;
      position: absolute;
      bottom: -1.5px;
      transition-duration: var(--animate-duration);
      transition-property: all;
    }
  }
  &__list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 23px;
    width: 99%;
    &__item {
      text-align: left;
      color: var(--reading-color);
      cursor: pointer;
      font-weight: 400;
      font-size: 12px !important;
      line-height: 14px !important;
      white-space: pre-wrap;
      &.selected {
        color: var(--action-color);
      }
      span {
        font-size: 12px;
      }
    }
  }
  &__row {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    gap: 2px;
    .appointment-month-side-bar__row__button {
      border-radius: 0;
      &:first-child {
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
    &__button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'Lato', sans-serif;
      border-radius: 4px;
      font-size: 12px;
      height: 30px;
      width: 100%;
      background-color: #EAEFF3;
      color: #192A3E;
      &.select,
      &:hover {
        background-color: #0489E0;
        color: #FFFFFF;
      }
      &.disabled {
        background-color: var(--unfocus-color);
      }
    }
  }
}
@media print {
  .appointment-month-side-bar {
    display: none;
  }
}
</style>
